import React from 'react';
import { CustomPropertyAddEdit } from './CustomPropertyAddEdit';
import { CustomPropertyAddEditProps } from './CustomPropertyForm.types';
import { AdminAccommodationsTelemetryProvider } from '../../Accommodations.telemetry';

export const CustomProperty: React.FC<CustomPropertyAddEditProps> = props => {
  return (
    <AdminAccommodationsTelemetryProvider>
      <CustomPropertyAddEdit {...props} />
    </AdminAccommodationsTelemetryProvider>
  );
};
